import { render, staticRenderFns } from "./TenantRestricted.vue?vue&type=template&id=786701b4&scoped=true"
import script from "./TenantRestricted.vue?vue&type=script&lang=js"
export * from "./TenantRestricted.vue?vue&type=script&lang=js"
import style0 from "./TenantRestricted.vue?vue&type=style&index=0&id=786701b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786701b4",
  null
  
)

export default component.exports